import React, { useEffect, useState } from "react";
import { List, Typography, Spin, Alert } from "antd";

const { Text } = Typography;

const IngredientSummary = ({ ingredientSummary, readonly, portions, requiredportions }) => {
  const [ingredients, setIngredients] = useState([]);
  const [loading, setLoading] = useState(Boolean(ingredientSummary));
  const [error, setError] = useState(null);
  const [conversionfactor, setConversionFactor] = useState(1);

  console.log('IngredientSummary props:', { readonly, portions, requiredportions, conversionfactor });

  useEffect(() => {
    if (!ingredientSummary) {
      setIngredients([]);
      setLoading(false);
      setConversionFactor(1);
      return;
    }

    setIngredients(ingredientSummary);
    setLoading(false);

    // Recalculate conversion factor whenever these change
    if (readonly && requiredportions && portions && portions > 0) {
      const factor = requiredportions / portions;
      setConversionFactor(factor);
    } else {
      setConversionFactor(1);
    }
  }, [ingredientSummary, readonly, requiredportions, portions]);

  if (loading) return <Spin tip="Loading ingredients..." />;
  if (error) return <Alert type="error" message={error} />;

  return (
    <List
      style={{ 
        maxWidth: 700, 
        margin: 'auto', 
        background: 'rgba(255,255,255,0.85)', 
        borderRadius: 12, 
        boxShadow: '0 4px 32px rgba(0,0,0,0.06)',  
        padding: '24px', 
        border: '2px solid #fff' 
      }}
      bordered
      dataSource={ingredients}
      renderItem={(item) => {
        const value = item.methodIngredient.quantity * conversionfactor;
        const displayValue = value % 1 === 0 ? value.toString() : value.toFixed(2);
        
        return (
          <List.Item>
            <Text>
              {displayValue} {item.methodIngredient.quantityType} {item.food.name}
            </Text>
          </List.Item>
        );
      }}
      locale={{ emptyText: "No ingredients found for this recipe." }}
    />
  );
};

export default IngredientSummary;
